<template>
  <v-dialog v-model="isOpen" max-width="500px">
    <div class="card card-custom card-stretch">
      <div class="card-header border-0 pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label text-dark">
            Confirm User Removal
          </span>
        </h3>
      </div>

      <div class="card-body border-0">
        <div class="text-center mb-4">
          <v-icon color="warning" size="64" class="mb-3">mdi-alert-circle</v-icon>
        </div>
        <p class="text-center mb-4">
          Are you sure you want to remove the user
          <strong>{{ user ? user.username || user.email : "N/A" }}</strong
          >?
        </p>
        <div class="alert alert-warning mb-4">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          This action cannot be undone. The user will lose access to the system immediately.
        </div>
      </div>

      <div class="d-flex justify-content-end pb-5 px-5">
        <v-btn class="ml-4" @click="close()">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn color="error" class="ml-4" @click="confirmRemoval()">
          {{ $t("common.delete") || "Delete User" }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: "confirmation-dialog",
  data() {
    return {
      isOpen: false,
      user: null
    };
  },
  methods: {
    open(user) {
      console.log("Opening confirmation dialog for user:", user);
      this.user = user;
      this.isOpen = true;
    },
    close() {
      this.user = null;
      this.isOpen = false;
    },
    async confirmRemoval() {
      // Emit event to parent component to handle the actual removal
      this.$emit("confirm-removal", this.user);
      this.close();
    }
  }
};
</script>
